import { EntityDialog, HtmlContentEditor, Authorization, Config, Culture, ErrorHandling } from "@serenity-is/corelib";
import { getSelectedLanguage } from "../_Ext/_q/_q";
import { IdleTimeout } from "./Helpers/IdleTimeout";
import { siteLanguageList } from "./Helpers/LanguageList";

Config.rootNamespaces.push('NubeBlink');
Config.rootNamespaces.push('_Ext');
EntityDialog.defaultLanguageList = siteLanguageList;
HtmlContentEditor.CKEditorBasePath = "~/Serenity.Assets/Scripts/ckeditor/";

if ($.fn['colorbox']) {
    $.fn['colorbox'].settings.maxWidth = "95%";
    $.fn['colorbox'].settings.maxHeight = "95%";
}

window.onerror = ErrorHandling.runtimeErrorHandler;

//HACK split agregado por choss porque en el inline editor fallaba porque se pasaba un array cuando debe ser string y hace un split pero para evitar ese problema se agrega este metodo de extension que solventa problema
//(<any>Array.prototype).split = function (): string[] {
//    return this;
//}
//Agrega el evento search para que dispare el evento change ya que actualmente no hace el change cuando se preciona la tachita del buscar
$('input[type=search]').on('search', function () {
    this.dispatchEvent(new Event('change'));
});
if (getSelectedLanguage().toLowerCase().startsWith('es')) {
    Culture.monthNames = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre', ''];
    Culture.shortMonthNames = ['Ene.', 'Feb.', 'Mar.', 'Abr.', 'May.', 'Jun.', 'Jul.', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic', ''];
    Culture.dayNames = ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'];
    Culture.shortDayNames = ['Dom.', 'Lun.', 'Mar.', 'Mié.', 'Jue.', 'Vie.', 'Sáb.'];

}

//Configuracion del cierre de sesion
$(() => {

    var meta = $('meta[name=username]');

    if ((meta.length && meta.attr('content')) ||
        (!meta.length && Authorization.isLoggedIn)) {
        //Configura el tiempo de inactividad que es por default 15 minutos
        new IdleTimeout({
            activityTimeout: 15 * 60,
            warningDuration: 2 * 60
        });
    }
});
